import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppGlobals } from '@app/app.global';
import { AuthService, SharedService } from '@app/core';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  host: {
    style: "display:block;",
    class: "loginwrapper",
    "[attr.tabindex]": "-1",
  }
})
export class LoginComponent implements OnInit, AfterViewInit {
  @ViewChild('passwordInput') passwordInput: ElementRef;
  errorMessage: string = '';
  loginForm: FormGroup;
  returnUrl: string[];
  isLoginFormVisible: boolean = true;
  isPasswordVisible: boolean = false;
  isSubmitAttempted: boolean = false;
  successMessage: string;
  reCaptchaResponse = "";

  constructor(private route: ActivatedRoute,
    public router: Router,
    private formBuilder: FormBuilder,
    public appGlobals: AppGlobals,
    public sharedService: SharedService,
    private authService: AuthService,
    private changeDetectorRef: ChangeDetectorRef) {
    // redirect to home if already logged in
    if (this.authService.isLoggedIn) {
      this.router.navigate(this.appGlobals.homePath);
    }
  }

  ngOnInit(): void {
    this.createLoginForm();
    // get return url from route parameters or default to home path
    this.returnUrl = this.route.snapshot.params['returnUrl'] ?
      [this.route.snapshot.params['returnUrl']] :
      this.appGlobals.homePath;
  }

  ngAfterViewInit(): void {
    this.sharedService.successMessage$.subscribe((message) => {
      this.successMessage = message;
      this.changeDetectorRef.detectChanges(); // Manually trigger change detection
    });
  }

  get f() { return this.loginForm.controls; }

  login() {
    this.isSubmitAttempted = true;

    if (this.loginForm.invalid) {
      // this.sharedService.errorAlert('Please enter valid credentials.');
      this.errorMessage = 'Please enter valid credentials.';
    } else {

      this.authService.login(
        this.f.username.value,
        this.f.password.value,
        this.reCaptchaResponse,
        this.f.rememberMe.value
      ).pipe(take(1)).subscribe((res: any) => {
        let routingPath = this.returnUrl;

        if (this.authService.user.isLeadAdmin) {
          if (this.authService.user.email === this.appGlobals.leadAdminModuleAccessUser) {
            routingPath = this.appGlobals.leadAdminPath;
          } else {
            routingPath = ['kyc-details'];
          }
        } else if (this.authService.user.isAdmin) {
          routingPath = this.appGlobals.adminPath;
        }

        this.router.navigate(routingPath);
      }, (error: any) => {
        console.log(error);
        // this.sharedService.errorAlert(error);
        this.errorMessage = error;
      });
    }
  }

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
    this.passwordInput.nativeElement.focus();
  }

  createLoginForm() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(this.appGlobals.loginMinPasswordLength)]],
      recaptcha: ['', Validators.required],
      rememberMe: [true]
    })

    this.f.username.valueChanges.subscribe(username => {
      this.f.username.setValidators([
        Validators.required,
        Validators.pattern(this.appGlobals.regex[username && username.includes('@') ? 'email' : 'mobile'])
      ]);
      this.f.username.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    });
  }

  onCaptchaResolved(captchaResponse: string) {
    this.reCaptchaResponse = captchaResponse;
  }

}